import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inline-flex w-full pt-4 border-0 border-solid border-b-2 border-b-subtle" }

import { computed } from 'vue';
import { useStore } from 'vuex';
import get from 'lodash/get';
import Icon from '@/components/ui/Icon.vue';
import IfPlan from '@/components/util/IfPlan';


export default /*#__PURE__*/_defineComponent({
  __name: 'ObjectTypeTabs',
  props: {
  activeTab: {
    type: String,
    required: true,
  },
  object: {
    type: Object,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const store = useStore();


const tabTriggerClasses = 'inline-flex items-center gap-1 relative text-default px-4 pb-1.5 font-normal hover:text-emphasis';
const tabTriggerActiveClasses = 'text-gradient-primary before:bg-gradient-1 before:absolute before:-bottom-0.5 before:left-0 before:right-0 before:h-0.5 [&>svg]:fill-[url(#svg-bg-gradient)]';

const objectKey = computed(() => props.object?.key ?? '');

const app = computed(() => store.getters.app);

const isUserRoleObject = computed(() => Boolean(props.object?.profile_key));

const hasAccessControlExtension = computed(() => {
  const extensions = get(app.value, 'settings.extensions', []);

  return Array.isArray(extensions) && extensions.includes('access_control');
});

const showDataAccess = computed(() => isUserRoleObject.value && hasAccessControlExtension.value);


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_RouterLink, {
      class: _normalizeClass([tabTriggerClasses, {
        [tabTriggerActiveClasses]: __props.activeTab === 'fields'
      }]),
      to: `/schema/list/objects/${_unref(objectKey)}`
    }, {
      default: _withCtx(() => [
        _createVNode(Icon, {
          class: "w-4",
          type: "bi-columns"
        }),
        _createTextVNode(" Column Fields ")
      ]),
      _: 1
    }, 8, ["class", "to"]),
    _createVNode(_component_RouterLink, {
      class: _normalizeClass([tabTriggerClasses, {
        [tabTriggerActiveClasses]: __props.activeTab === 'records'
      }]),
      to: `/records/objects/${_unref(objectKey)}`
    }, {
      default: _withCtx(() => [
        _createVNode(Icon, {
          class: "w-6 fill-subtle",
          type: "tb-layout-list"
        }),
        _createTextVNode(" Record Rows ")
      ]),
      _: 1
    }, 8, ["class", "to"]),
    _createVNode(_component_RouterLink, {
      class: _normalizeClass([tabTriggerClasses, {
        [tabTriggerActiveClasses]: __props.activeTab === 'connections'
      }]),
      to: `/connections/objects/${_unref(objectKey)}`
    }, {
      default: _withCtx(() => [
        _createVNode(Icon, {
          class: "w-4",
          type: "pi-intersect-fill"
        }),
        _createTextVNode(" Connections ")
      ]),
      _: 1
    }, 8, ["class", "to"]),
    _createVNode(_unref(IfPlan), { "level-is-maximum-of": 1 }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass([tabTriggerClasses, {
          [tabTriggerActiveClasses]: __props.activeTab === 'tasks'
        }, 'cursor-pointer']),
          "data-cy": "tasks-for-upgrade"
        }, [
          _createVNode(Icon, {
            class: "w-3 mr-0.5 fill-subtle",
            type: "action-task-2"
          }),
          _createTextVNode(" Tasks ")
        ], 2)
      ]),
      _: 1
    }),
    _createVNode(_unref(IfPlan), { "level-is-minimum-of": 2 }, {
      default: _withCtx(() => [
        _createVNode(_component_RouterLink, {
          class: _normalizeClass([tabTriggerClasses, {
          [tabTriggerActiveClasses]: __props.activeTab === 'tasks'
        }]),
          to: `/tasks/objects/${_unref(objectKey)}`
        }, {
          default: _withCtx(() => [
            _createVNode(Icon, {
              class: "w-3 mr-0.5 fill-subtle",
              type: "action-task-2"
            }),
            _createTextVNode(" Tasks ")
          ]),
          _: 1
        }, 8, ["class", "to"])
      ]),
      _: 1
    }),
    (_unref(showDataAccess))
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 0,
          class: _normalizeClass([tabTriggerClasses, {
        [tabTriggerActiveClasses]: __props.activeTab === 'data-access'
      }]),
          to: `/data-access/objects/${_unref(objectKey)}`,
          "data-cy": "quick-nav-data-access"
        }, {
          default: _withCtx(() => [
            _createVNode(Icon, {
              class: "w-4",
              type: "lock-outline"
            }),
            _createTextVNode(" Data Access ")
          ]),
          _: 1
        }, 8, ["class", "to"]))
      : _createCommentVNode("", true)
  ]))
}
}

})